/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ComponentPropsEmptyStateIcon(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ComponentPropsEmptyStateIcon',
      'aria-hidden': true,
      focusable: false,
      width:  64 * scale,
      height: 64 * scale,
      viewBox: '0 0 64 64',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M32.494 14.062a1 1 0 0 0-.992 0l-15.5 8.857a1 1 0 0 0-.504.869v17.705a1 1 0 0 0 .504.868l15.5 8.857a1 1 0 0 0 .992 0l15.5-8.857a1 1 0 0 0 .504-.868V23.788a1 1 0 0 0-.504-.869zm14.496 9.435L31.998 14.93l-14.992 8.567 14.992 8.567zm-30.492.862v17.134l15 8.571V32.93zm16 25.705 15-8.571V24.359l-15 8.571z","fill":"currentColor"}),createElement('path', {"opacity":".2","fillRule":"evenodd","clipRule":"evenodd","d":"M31.497 6.713a1 1 0 0 1 1.002 0L54 19.173a1 1 0 0 1 .499.865v24.924a1 1 0 0 1-.498.865l-21.5 12.46a1 1 0 0 1-1.003 0l-21.5-12.46a1 1 0 0 1-.499-.865V20.038a1 1 0 0 1 .499-.865l21.5-12.46zm.501.865-21.5 12.46v24.924l21.5 12.46 21.5-12.46V20.038z","fill":"currentColor"}),createElement('path', {"opacity":".3","d":"m48 23.5-16 9V51l16-9.5z","fill":"currentColor"}))
}
